import { Injectable } from '@angular/core';
import { RxapDataSource } from 'eurogard-data-source';
import { GetByFilterToTableMethod } from './get-by-filter-to-table.method';
import { DynamicTableDataSource } from 'eurogard-data-source/table';

import { TypedDashboard } from './typed.dashboard';
import { LinkDashboardTableMethod } from './link-dashboard-table.method';

@Injectable()
@RxapDataSource('link-dashboard-table')
export class LinkDashboardTableDataSource extends DynamicTableDataSource<TypedDashboard> {

  constructor(
    getByFilter: LinkDashboardTableMethod,
  ) {
    super(new GetByFilterToTableMethod(getByFilter));
  }

}
